








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { OrgFeatureKeys } from "@/data/constants";
import { UpmindClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "upmind-upgrade-provider": () =>
      import("@/components/app/admin/upmind/upgradeProvider.vue"),
    "upmind-license-card": () =>
      import("@/components/app/admin/upmind/licenseCard.vue")
  }
})
export default class UpmindUpgradeModal extends Vue {
  @Prop({ default: () => i18n.t("_action.close") })
  public readonly cancelText!: string;

  @Prop({ default: () => [] })
  public readonly missingKeys!: OrgFeatureKeys[];

  // Data

  public cpInvoicesRoute = UpmindClientRoutes.CONTRACT_PRODUCT_BILLING;
}
